const indexedPaths = {
  "fastqrgenerator.com": ["/", "/contact-us"],
  "qrcreator.com": ["/", "/contact-us"],
  "onlineqrcode.com": ["/", "/faq", "/pricing", "/contact-us", "/who-we-are"],
}

module.exports = {
  indexedPaths
}